var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_c('app-leftnav',{attrs:{"info":_vm.info},on:{"update_messages_data":function($event){return _vm.updateMessages($event)}}}),_c('app-content',{attrs:{"messages":_vm.messages}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }